import { sanitizeHtml } from '../../util/transform';
import type { IAccountExchange } from './AccountExchange.interface';

export default class AccountExchange implements IAccountExchange {
  alias: any;
  eMail: {
    from: string,
    replyTo: string,
    bcc: string,
    signature: string
  };

  sms: {
    bcc: string,
    signature: string
  };

  static build = (data: IAccountExchange) => new AccountExchange(data);
  static blank = () => new AccountExchange();

  /**
   * Constructor
   * @param {IAccountExchange} data
   */
  constructor(data?: IAccountExchange) {
    this.alias = data?.alias || undefined;
    this.eMail = {
      from: data?.eMail?.from || '',
      replyTo: data?.eMail?.replyTo || '',
      bcc: data?.eMail?.bcc || '',
      signature: sanitizeHtml(data?.eMail?.signature || '')
    };
    this.sms = {
      bcc: data?.sms?.bcc || '',
      signature: sanitizeHtml(data?.sms?.signature || '')
    };
  }
}
